// Operator-kind compatibility per ontology spec §10.
// Filters the list of trigger operators based on the selected property type's kind.
// Used by FrontmatterForm to show only the operators that make sense for the
// chosen property.

import type { TriggerOp } from "@/types/agent-skills";

export type PropertyKind = "string" | "number" | "date" | "bool" | "currency" | "enum" | "ref";

const COMPATIBILITY: Record<PropertyKind, TriggerOp[]> = {
  string: ["equals", "contains", "regex"],
  number: ["equals", "gt", "lt"],
  currency: ["equals", "gt", "lt"],
  date: ["equals", "gt", "lt"],
  bool: ["equals"],
  enum: ["equals"],
  ref: ["equals"],
};

const ALL_OPERATORS: TriggerOp[] = ["equals", "contains", "gt", "lt", "regex"];

/** Returns the operators that are valid for the given property kind.
 *  When kind is null/unknown, returns all operators (back-compat fallback). */
export function compatibleOperators(kind: PropertyKind | string | null | undefined): TriggerOp[] {
  if (!kind) return ALL_OPERATORS;
  return COMPATIBILITY[kind as PropertyKind] ?? ALL_OPERATORS;
}

export function isCompatible(
  kind: PropertyKind | string | null | undefined,
  op: TriggerOp
): boolean {
  return compatibleOperators(kind).includes(op);
}
